import { responsiveFontSizes, createTheme } from '@mui/material/styles';

export default responsiveFontSizes(createTheme({
    typography: {
        fontFamily: "'Montserrat', sans-serif", // Replace 'Roboto' with your desired font
    },
    palette: {
        background: {
            default: '#F2F4F8',
            paper: '#fff'
        },
        text: {
            primary: '#1A263E',
            secondary: '#B5ADC4'
        },
        primary: {
            main: '#0188ac',
        },
        secondary: {
            main: '#619f11'
        },
        warning: {
            main: '#f37360'
        },
        error: {
            main: '#dc143c'
        },
        success: {
            main: '#619f11'
        }
    },
    components: {
        MuiTableRow: {
            styleOverrides: {
                root: {
                    '&:nth-of-type(odd)': {
                        backgroundColor: '#F2F4F8',
                    },
                },
            }
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    '& tr': {
                        backgroundColor: '#fff!important'
                    }
                }
            }
        },
        MuiTableContainer: {
            styleOverrides: {
                root: {
                    width: '100%'
                }
            }
        },
        MuiTableBody: {
            styleOverrides: {
                root: {
                    width: '100%'
                }
            }
        },
        MuiTableCell: {
            defaultProps: {
                align: 'center',
            }
            //,
            //styleOverrides: {
            //    root: {
            //        whiteSpace: "nowrap",
            //        textOverflow: "ellipsis",
            //        maxWidth: "120px",
            //        overflow: "hidden"
            //    }
            //}
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    padding: '8px',
                    borderRadius: '12px',
                }
            }
        },
        MuiAppBar: {
            styleOverrides: {
                root: {
                    borderRadius: '0px',
                }
            }
        },
        MuiContainer: {
            styleOverrides: {
                root: {
                    padding: '8px'
                }
            }
        },
        MuiGrid2: {
            defaultProps: {
                spacing: 1,
                justifyContent: 'space-between',
                alignItems: 'stretch'
            }
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    color: 'primary',
                }
            }
        },
        MuiButton: {
            defaultProps: {
                variant: 'contained',
                fullWidth: true
            },
            styleOverrides: {
                root: {
                    borderRadius: '12px',
                }
            }
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    borderRadius: '12px',
                }
            },
            defaultProps: {
                fullWidth: true,
                size: 'small',
                margin: 'none'
            }
        },
        MuiTextField: {
            defaultProps: {
                fullWidth: true,
                size: 'small',
                margin: 'none'
            }
        },
        MuiTypography: {
            defaultProps: {
                variant: 'body2'
            }
        },
    }
}));